<div *ngIf="projectHeader$ | async as projectHeader">

    <!-- ng-style="projectNameShadowStyle" Project Name [innerHTML]="projectHeader.projectName | highlight: searchTerm" -->
    <div class="row">
        <div class="developmentName col-md-12" [innerHTML]="projectHeader.projectName | highlight: searchTerm">
            {{projectHeader.discriminator}}
        </div>
    </div>
    <!-- /Project Name -->

    <ng-container *ngTemplateOutlet="template; context: { $implicit: projectHeader}"></ng-container>

    <!-- Description -->
    <div class="sectionContainer" *ngIf="projectHeader.projectProfile">
        <h3>Description</h3>
        <table class="projectSectionTable">
            <tr>

                <td id="profile" class="item" [innerHTML]="projectHeader.projectProfile | highlight: searchTerm">
                    {{projectHeader.projectProfile}}
                </td>
            </tr>
        </table>

    </div>
    <!-- /Description -->

</div>


<!-- Template Definitions -->
<ng-template #projectCapex let-projectHeader>
    <!-- Template for Project CAPEX -->
    <!-- <p>Project CAPEX Template</p> -->
    <div>EIC ProjectID: {{projectHeader.projectID}}</div>


    <!-- Alternative Project Name(s) -->
    <div class="sectionContainer" *ngIf="projectHeader.alternativeNames.length>0">
        <div>
            <h3>This project is also known as:</h3>
            <ul>
                <li class="list-unstyled" *ngFor="let alternativeName of projectHeader.alternativeNames"
                    [innerHTML]="alternativeName | highlight: searchTerm"></li>
            </ul>
        </div>
    </div>
    <!-- / Alternative Project Name(s) -->

    <!-- ProjectDetails -->
    <div class="sectionContainer">
        <h3>Project Details</h3>
        <table stackable-table class="projectSectionTable">
            <thead>
                <tr>
                    <th class="itemHeading">Industry Sector</th>
                    <th class="itemHeading">Project Type</th>
                    <th class="itemHeading">Terrain</th>
                    <th class="itemHeading alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        Water depth&nbsp;(m)
                    </th>
                    <th class="itemHeading alignRight">Value ($M)</th>
                    <th class="itemHeading alignRight">Startup</th>
                    <th class="itemHeading">Project Stage</th>
                    <th class="itemHeading">Project Status</th>
                    <th class="itemHeading">Tracking Status</th>
                    <th class="itemHeading alignRight">Updated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="item">
                        <span [innerHTML]="projectHeader.energySector | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectType | highlight: searchTerm"></span>
                    </td>
                    <td class="item terrain">
                        <span>
                            <ul class="plainList">
                                <li *ngFor="let terrain of projectHeader.projectTerrains">
                                    {{terrain}}
                                </li>

                            </ul>
                        </span>
                    </td>

                    <td class="item alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        {{projectHeader.waterDepth}}
                    </td>
                    <td class="item alignRight">
                        {{projectHeader.dollarValue | currency}}
                    </td>
                    <td class="item alignRight">
                        {{projectHeader.startupMonth}}
                        {{projectHeader.startupYear}}
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectStage | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.trackingStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item noWrap">
                        {{projectHeader.updated | date:'d MMM yyyy'}}
                    </td>
                </tr>
                <tr *ngIf="projectHeader.projectStage=='Term'">
                    <td></td>
                    <td>Term Start: </td>
                    <td>{{projectHeader.termStart}}</td>
                    <td>Term Finish: </td>
                    <td>{{projectHeader.termFinish}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- /ProjectDetails -->
</ng-template>

<ng-template #projectOpex let-projectHeader>
    <!-- Template for Project OPEX -->
    <!-- <p>Project OPEX Template</p> -->
    <div>EIC ProjectID: {{projectHeader.projectID}}</div>
    
    
    <!-- Alternative Project Name(s) -->
    <div class="sectionContainer" *ngIf="projectHeader.alternativeNames.length>0">
        <div>
            <h3>This project is also known as:</h3>
            <ul>
                <li class="list-unstyled" *ngFor="let alternativeName of projectHeader.alternativeNames"
                    [innerHTML]="alternativeName | highlight: searchTerm"></li>
            </ul>
        </div>
    </div>
    <!-- / Alternative Project Name(s) -->
    
    <!-- ProjectDetails -->
    <div class="sectionContainer">
        <h3>Project Details</h3>
        <table stackable-table class="projectSectionTable">
            <thead>
                <tr>
                    <th class="itemHeading">Industry Sector</th>
                    <th class="itemHeading">Project Type</th>
                    <th class="itemHeading">Terrain</th>
                    <th class="itemHeading alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        Water depth&nbsp;(m)
                    </th>
                    <th class="itemHeading alignRight">Value ($M)</th>
                    <th class="itemHeading alignRight">Startup</th>
                    <th class="itemHeading">Project Stage</th>
                    <th class="itemHeading">Project Status</th>
                    <th class="itemHeading">Tracking Status</th>
                    <th class="itemHeading alignRight">Updated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="item">
                        <span [innerHTML]="projectHeader.energySector | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectType | highlight: searchTerm"></span>
                    </td>
                    <td class="item terrain">
                        <span>
                            <ul class="plainList">
                                <li *ngFor="let terrain of projectHeader.projectTerrains">
                                    {{terrain}}
                                </li>
    
                            </ul>
                        </span>
                    </td>
    
                    <td class="item alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        {{projectHeader.waterDepth}}
                    </td>
                    <td class="item alignRight">
                        {{projectHeader.dollarValue | currency}}
                    </td>
                    <td class="item alignRight">
                        {{projectHeader.startupMonth}}
                        {{projectHeader.startupYear}}
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectStage | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.trackingStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item noWrap">
                        {{projectHeader.updated | date:'d MMM yyyy'}}
                    </td>
                </tr>
                <tr *ngIf="projectHeader.projectStage=='Term'">
                    <td></td>
                    <td>Term Start: </td>
                    <td>{{projectHeader.termStart}}</td>
                    <td>Term Finish: </td>
                    <td>{{projectHeader.termFinish}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- /ProjectDetails -->
</ng-template>

<ng-template #projectAbex let-projectHeader>
    <!-- Template for Project ABEX -->
    <!-- <p>Project ABEX Template</p> -->
    <div>EIC ProjectID: {{projectHeader.projectID}}</div>
    
    
    <!-- Alternative Project Name(s) -->
    <div class="sectionContainer" *ngIf="projectHeader.alternativeNames.length>0">
        <div>
            <h3>This project is also known as:</h3>
            <ul>
                <li class="list-unstyled" *ngFor="let alternativeName of projectHeader.alternativeNames"
                    [innerHTML]="alternativeName | highlight: searchTerm"></li>
            </ul>
        </div>
    </div>
    <!-- / Alternative Project Name(s) -->
    
    <!-- ProjectDetails -->
    <div class="sectionContainer">
        <h3>Project Details</h3>
        <table stackable-table class="projectSectionTable">
            <thead>
                <tr>
                    <th class="itemHeading">Industry Sector</th>
                    <th class="itemHeading">Project Type</th>
                    <th class="itemHeading">Terrain</th>
                    <th class="itemHeading alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        Water depth&nbsp;(m)
                    </th>
                    <th class="itemHeading alignRight">Value ($M)</th>
                    <th class="itemHeading alignRight">Startup</th>
                    <th class="itemHeading">Project Stage</th>
                    <th class="itemHeading">Project Status</th>
                    <th class="itemHeading">Tracking Status</th>
                    <th class="itemHeading alignRight">Updated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="item">
                        <span [innerHTML]="projectHeader.energySector | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectType | highlight: searchTerm"></span>
                    </td>
                    <td class="item terrain">
                        <span>
                            <ul class="plainList">
                                <li *ngFor="let terrain of projectHeader.projectTerrains">
                                    {{terrain}}
                                </li>
    
                            </ul>
                        </span>
                    </td>
    
                    <td class="item alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        {{projectHeader.waterDepth}}
                    </td>
                    <td class="item alignRight">
                        {{projectHeader.dollarValue | currency}}
                    </td>
                    <td class="item alignRight">
                        {{projectHeader.startupMonth}}
                        {{projectHeader.startupYear}}
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectStage | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.projectStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.trackingStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item noWrap">
                        {{projectHeader.updated | date:'d MMM yyyy'}}
                    </td>
                </tr>
                <tr *ngIf="projectHeader.projectStage=='Term'">
                    <td></td>
                    <td>Term Start: </td>
                    <td>{{projectHeader.termStart}}</td>
                    <td>Term Finish: </td>
                    <td>{{projectHeader.termFinish}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- /ProjectDetails -->
</ng-template>

<ng-template #assetOpex let-projectHeader>
    <!-- Template for Asset OPEX -->
    <div>EIC Asset ID: {{projectHeader.projectID}}</div>

    <!-- Alternative Name(s) -->
    <div class="sectionContainer" *ngIf="projectHeader.alternativeNames.length>0">
        <div>
            <h3>This asset is also known as:</h3>
            <ul>
                <li class="list-unstyled" *ngFor="let alternativeName of projectHeader.alternativeNames"
                    [innerHTML]="alternativeName | highlight: searchTerm"></li>
            </ul>
        </div>
    </div>
    <!-- / Alternative Project Name(s) -->

    <!-- Assset Details -->
    <div class="sectionContainer">
        <h3>Asset Details</h3>
        <table stackable-table class="projectSectionTable">
            <thead>
                <tr>
                    <th colspan="2"></th>
                    <th></th>
                    <th *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0"></th>
                    <th class="itemHeading" colspan="2" style="text-align: center;">Production</th>
                    <th colspan="2"></th>
                </tr>
                <tr>
                    <th class="itemHeading">Industry Sector</th>
                    <th class="itemHeading">Asset Type</th>
                    <th class="itemHeading">Terrain</th>
                    <th class="itemHeading alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        Water depth&nbsp;(m)
                    </th>
                    <th class="itemHeading">Start</th>
                    <th class="itemHeading">End</th>
                    <th class="itemHeading">Status</th>
                    <th class="itemHeading alignRight">Updated</th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td class="item">
                        <span [innerHTML]="projectHeader.energySector | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.assetType | highlight: searchTerm"></span>
                        <span *ngIf="projectHeader.assetSubtype">
                            (<span [innerHTML]="projectHeader.assetSubtype | highlight: searchTerm"></span>)
                        </span>
                    </td>
                    <td class="item terrain">
                        <span>
                            <ul class="plainList">
                                <li *ngFor="let terrain of projectHeader.projectTerrains">
                                    {{terrain}}
                                </li>

                            </ul>
                        </span>
                    </td>
                    <td class="itemHeading">
                        {{ projectHeader.assetDetails?.productionStartDate
                            ? (projectHeader.assetDetails?.productionStartDate | date:'d MMM yyyy')
                            : '&nbsp;&nbsp;–' }}
                    </td>
                    <td class="itemHeading">
                        {{ projectHeader.assetDetails?.productionEndDate
                            ? (projectHeader.assetDetails?.productionEndDate | date:'d MMM yyyy')
                            : '&nbsp;&nbsp;–' }}
                    </td>

                    <td class="item alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        {{projectHeader.waterDepth}}
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.assetStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item noWrap alignRight">
                        {{projectHeader.updated | date:'d MMM yyyy'}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- /Asset Details -->
</ng-template>


<ng-template #assetAbex let-projectHeader>
    <!-- Template for Asset ABEX -->
    <!-- <p>Asset ABEX Template</p> -->
    <div>EIC Asset ID: {{projectHeader.projectID}}</div>
    
    <!-- Alternative Name(s) -->
    <div class="sectionContainer" *ngIf="projectHeader.alternativeNames.length>0">
        <div>
            <h3>This asset is also known as:</h3>
            <ul>
                <li class="list-unstyled" *ngFor="let alternativeName of projectHeader.alternativeNames"
                    [innerHTML]="alternativeName | highlight: searchTerm"></li>
            </ul>
        </div>
    </div>
    <!-- / Alternative Project Name(s) -->
    
    <!-- Assset Details -->
    <div class="sectionContainer">
        <h3>Asset Details</h3>
        <table stackable-table class="projectSectionTable">
            <thead>
                <tr>
                    <th colspan="2"></th>
                    <th></th>
                    <th *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0"></th>
                    <th class="itemHeading" colspan="2" style="text-align: center;">Production</th>
                    <th colspan="2"></th>
                </tr>
                <tr>
                    <th class="itemHeading">Industry Sector</th>
                    <th class="itemHeading">Asset Type</th>
                    <th class="itemHeading">Terrain</th>
                    <th class="itemHeading alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        Water depth&nbsp;(m)
                    </th>
                    <th class="itemHeading">Start</th>
                    <th class="itemHeading">End</th>
                    <th class="itemHeading">Status</th>
                    <th class="itemHeading alignRight">Updated</th>
                </tr>
            </thead>
    
            <tbody>
                <tr>
                    <td class="item">
                        <span [innerHTML]="projectHeader.energySector | highlight: searchTerm"></span>
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.assetType | highlight: searchTerm"></span>
                        <span *ngIf="projectHeader.assetSubtype">
                            (<span [innerHTML]="projectHeader.assetSubtype | highlight: searchTerm"></span>)
                        </span>
                    </td>
                    <td class="item terrain">
                        <span>
                            <ul class="plainList">
                                <li *ngFor="let terrain of projectHeader.projectTerrains">
                                    {{terrain}}
                                </li>
    
                            </ul>
                        </span>
                    </td>
                    <td class="itemHeading">
                        {{ projectHeader.assetDetails?.productionStartDate
                        ? (projectHeader.assetDetails?.productionStartDate | date:'d MMM yyyy')
                        : '&nbsp;&nbsp;–' }}
                    </td>
                    <td class="itemHeading">
                        {{ projectHeader.assetDetails?.productionEndDate
                        ? (projectHeader.assetDetails?.productionEndDate | date:'d MMM yyyy')
                        : '&nbsp;&nbsp;–' }}
                    </td>
    
                    <td class="item alignRight" *ngIf="projectHeader.waterDepth && projectHeader.waterDepth > 0">
                        {{projectHeader.waterDepth}}
                    </td>
                    <td class="item">
                        <span [innerHTML]="projectHeader.assetStatus | highlight: searchTerm"></span>
                    </td>
                    <td class="item noWrap alignRight">
                        {{projectHeader.updated | date:'d MMM yyyy'}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- /Asset Details -->
    
</ng-template>